// extracted by mini-css-extract-plugin
export default {"tabContainer":"_176NnB71XN8ME28blVYTmF"};